import buildSubjectApiPath from '@Application/Subjects/buildSubjectApiPath';
import type * as React from 'react';
import interviewRenameFailed, {
	type InterviewRenameFailedAction,
} from '@Application/Beneficiaries/Interviews/Actions/interviewRenameFailed';
import interviewRenamed, {
	type InterviewRenamedAction,
} from '@Application/Beneficiaries/Interviews/Actions/interviewRenamed';
import type { InterviewPayload } from '@Application/Beneficiaries/Interviews/Actions/interviewsFetched';
import type RenameInterview from '@Application/Beneficiaries/Interviews/Commands/RenameInterview';
import { patch } from '@Domain/Api';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';

type Actions = InterviewRenamedAction | InterviewRenameFailedAction;

export default (command: RenameInterview) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const payload = await patch<InterviewPayload>(
				`${buildSubjectApiPath(command.facilityId, command.subject)}/interviews/${command.interviewId}`,
				command.toJSON(),
			);

			const action = interviewRenamed(payload, command.subject.typeKey, command.subject.subjectId);
			dispatch(action);
			return action;
		} catch (error) {
			const action = interviewRenameFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
